export default __webpack_public_path__ + "static/contact-us-13642fe97845d6a20935c7b06773b561.svg";